import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import Select from 'react-select'; // Import react-select
import { useNavigate, Link, NavLink } from 'react-router-dom';
import qs from 'qs';
import apiurl from './Api';
import styles from './Components/css/user.module.css';

axios.defaults.withCredentials = true;

function Login() {
    const [focus, setFocus] = useState({ username: false, password: false });

     const [passwordVisibility, setPasswordVisibility] = useState({
        isVisible: false,
      });
    
      const toggleVisibility = () => {
        setPasswordVisibility((prev) => ({
          isVisible: !prev.isVisible,
        }));
      };

    const [loading, setLoading] = useState(false);
    
    // New States
    const [roles, setRoles] = useState([]); 
    const [tempCreds, setTempCreds] = useState({ phone: '', password: '' });

    const navigate = useNavigate();

    const FormSubmit = async (e, selectedUsername = null) => {
        if (e) e.preventDefault();
       
        const phone = selectedUsername ? tempCreds.phone : e.target.phone.value;
        const password = selectedUsername ? tempCreds.password : e.target.password.value;

        setLoading(true);
        try {
            const response = await axios.post(
                apiurl + "login.php",
                qs.stringify({
                    username: phone,
                    password: password,
                    subdomain: "react",
                    selectpost: selectedUsername // This tells PHP to finalize
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            );

            if (response.data.status === "select_post") {
                setTempCreds({ phone, password });
                setRoles(response.data.roles);
            } else if (response.data.status === true) {
                Swal.fire({ icon: "success", title: "Login Successful", timer: 1500,showConfirmButton: false }).then(()=>{
                    navigate("/admin");
                });
                
            } else {
                Swal.fire({ icon: "error", title: response.data.message });
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(()=>{
       document.title='LOGIN | AIP MERAQUI';
    },[]);

    return (
        <>
            {/* ROLE SELECTION MODAL OVERLAY */}
            {roles.length > 0 && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 999,
                    display: 'flex', justifyContent: 'center', alignItems: 'center'
                }}>
                    <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '10px', width: '90%', maxWidth: '400px' }}>
                        <h5 className="mb-3">Select Your Post</h5>
                        <p className="text-muted small">Multiple accounts found for this number.</p>
                        
                        <Select 
                            options={roles}
                            placeholder="Search & Select Post..."
                            onChange={(opt) => FormSubmit(null, opt.value)}
                            autoFocus
                        />

                        <button 
                            onClick={() => setRoles([])} 
                            className="btn btn-sm btn-light mt-4 w-100"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            )}

            <div className="l-form">
                <div className="shape1"></div>
                <div className="shape2"></div>
                <div className="form">
                    <img src={process.env.PUBLIC_URL + "/admin_assets/images/media/authentication.svg"} alt="" className="form__img" />
                    
                    <form onSubmit={FormSubmit} className='form__content'>
                        {/* ... Your Existing Username/Password Fields ... */}
                        <div className="mb-3" style={{textAlign:'center'}}>
                            <img src={"/images/meraqui-logo.png"} className="authentication-brand" style={{filter:'invert(1)', height:'2rem'}}/>
                        </div>
                        <p className="h5 fw-semibold mb-2">Welcome To Meraqui Venture</p>

                        <div className={`form__div form__div-one ${focus.username ? "focus" : ""}`} style={{marginTop:'35px'}}>
                            <div className="form__icon"><i className="bx bx-user-circle"></i></div>
                            <div className="form__div-input">
                                <label className="form__label">Username</label>
                                <input type="text" className="form__input" name='phone' onFocus={() => setFocus({...focus, username: true})} onBlur={(e) => setFocus({...focus, username: e.target.value !== ""})} />
                            </div>
                        </div>

                        <div className={`form__div ${focus.password ? "focus" : ""}`}>
                            <div className="form__icon"><i className="bx bx-lock"></i></div>
                            <div className="form__div-input" style={{ display: "flex", justifyContent: "flex-end" }}>
                                <label className="form__label">Password</label>
                                <input type={passwordVisibility.isVisible ? "text" : "password"} className="form__input" name="password" onFocus={() => setFocus({...focus, password: true})} onBlur={(e) => setFocus({...focus, password: e.target.value !== ""})} />
                                <button style={{cursor:'pointer',position:'absolute',top:'-4px'}} className="btn btn-light" onClick={toggleVisibility} type="button">
                                    <i className={passwordVisibility.isVisible ? "ri-eye-line" : "ri-eye-off-line"}></i>
                                </button>
                            </div>
                        </div>
                        <NavLink className="text-primary" to="/forgot" data-discover="true" style={{float: 'right',marginBottom: '20px', fontWeight: '600'}}>Forgot Password ?</NavLink>

                        <button type="submit" className="form__button" disabled={loading}>
                            {loading ? <span className="spinners"></span> : "Login"}
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
}
export default Login;
